import * as Sentry from '@sentry/vue'

// Identifica no Sentry de qual empresa/usuário veio cada erro ou lentidão, para
// investigar a reclamação de um cliente sem depender de IP e horário.
// Só ids, perfil e CNPJ — nada de nome ou e-mail. CPF (empresa MEI cadastrada
// com CPF) não é enviado: é dado pessoal.
const TAGS = ['empresa_id', 'empresa_cnpj', 'perfil_id', 'area', 'suporte']

const somenteDigitos = valor => String(valor || '').replace(/\D/g, '')

const limpar = () => {
    Sentry.setUser(null)
    TAGS.forEach(tag => Sentry.setTag(tag, undefined))
}

export const identificarUsuarioNoSentry = ({ userData, empresaData, impersonacao } = {}) => {
    try {
        if (!userData || !userData.id) {
            limpar()
            return
        }

        // Usuário de empresa tem empresa_id; cliente final (área do cliente) não.
        if (userData.empresa_id) {
            const cnpj = somenteDigitos(empresaData && empresaData.cpfcnpj)

            Sentry.setUser({ id: `usuario-${userData.id}` })
            Sentry.setTags({
                area: 'empresa',
                empresa_id: String(userData.empresa_id),
                empresa_cnpj: cnpj.length === 14 ? cnpj : undefined,
                perfil_id: userData.perfil_id ? String(userData.perfil_id) : undefined,
                suporte: impersonacao ? 'sim' : undefined,
            })
            return
        }

        Sentry.setUser({ id: `cliente-${userData.id}` })
        Sentry.setTags({
            area: 'cliente',
            empresa_id: undefined,
            empresa_cnpj: undefined,
            perfil_id: undefined,
            suporte: undefined,
        })
    } catch (e) {
        // Observabilidade nunca pode quebrar o login.
    }
}
